/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,jsx-a11y/role-supports-aria-props */
import React, { useEffect, useState, useRef, useContext } from "react";
import { useDispatch } from "react-redux";
import { shallowEqual, useSelector } from "react-redux";
import * as actions from "../../_redux/actions";
import { AEInput } from "../../../../../_metronic/_partials/controls";
import { useSubheader } from "../../../../../_metronic/layout";
import { ModalProgressBar } from "../../../../../_metronic/_partials/controls";
import { CONTEXT } from "../../helpers/ModuleHelpers";
import { EntityCard } from "../../componants/EntityCard";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import { AESVG } from "../../../../../_emywork/components/svg";
import { AEButton } from "../../../../../_emywork/components/buttons";
import { AEMoment } from "../../../../../_emywork/components/moment";
import { EntityCard as UserEntityCard } from "../../../Users/componants/EntityCard";
import moment from "moment";
import { AEQRCode } from "../../../../../_emywork/components/AEQRCode";
import { AEShareButtons } from "../../../../../_emywork/components/AEShareButtons";
import { AEReport } from "../../../../../_emywork/components/AEReport";
import { AEFeed } from "../../../../../_emywork/components/AEFeed";
import { Proposals } from "./Proposals";
import { AEFileDownload } from "../../../../../_emywork/components/AEFileDownload";
import { AERole } from "../../../../../_emywork/components/AERole";
import { useIntl } from "react-intl";
import { actionTypes } from "../../_redux/slice";
import { AEMetadata } from "../../../../../_emywork/AEPagination";
import {
  localField,
  PAYMENT_TERMS,
} from "../../../../../_emywork/helpers/UIHelper";
import { useFormik } from "formik";
import {
  HTTP_CREATED,
  HTTP_NOT_FOUND,
  HTTP_PERMISSION_DENIED,
  HTTP_UPDATED,
} from "../../../../../_emywork/helpers/AxiosHelpers";
import * as projectCommentsActions from "../../../ProjectComments/_redux/actions";
import { AECurrency } from "../../../../../_emywork/components/Currency";
import { roles } from "../../../../../index";
import { getConfig } from "../../../../../_metronic/i18n";
import { ButtonGroup, Dropdown } from "react-bootstrap";
import { EmyProjectStatus } from "../../componants/Status";
import {
  getStatuses,
  getStatusesKeys,
  isReviewed,
} from "../../helpers/StatusHelpers";
import { ROUTES } from "../../helpers/RoutingHelpers";
import { updateEntity } from "../../_redux/actions";
import EditableFeedWrapper from "../../../../../_emywork/components/feeds/EditableFeedWrapper";

export function Details({
  history,
  match: {
    params: { slug },
  },
}) {
  const { formatMessage } = useIntl();
  const subheader = useSubheader();
  const dispatch = useDispatch();
  const { authUser } = useSelector(
    ({ auth }) => ({ authUser: auth.user }),
    shallowEqual
  );
  const { isLoading, entity } = useSelector((state) => {
    const s = state[CONTEXT][actionTypes.Details];
    return {
      isLoading: s.isLoading,
      entity: s.entity,
    };
  }, shallowEqual);
  // console.log({ entity });
  const commentFormik = useFormik({
    initialValues: {
      project_id: entity.id,
      parent_id: null,
      user_id: authUser.id,
      message: "",
      enabled: true,
    },
    onSubmit: (values) => {
      //todo type
      dispatch(projectCommentsActions.createEntity(values)).then((r) => {
        if (r.status === HTTP_CREATED) {
          getEntity();
        }
      });
    },
  });
  const { handleSubmit, getFieldProps } = commentFormik;

  const [currentRoute, setCurrentRoute] = useState();
  const getEntity = () => {
    dispatch(
      actions.fetchEntity(
        slug,
        new AEMetadata(
          {},
          {},
          {},
          [
            "id",
            "file_name",
            "title",
            "slug",
            "price",
            "hours_per_week",
            "duration",
            "user_id",
            "description",
            "created_at",
            "quotes_end_at",
            "status",
            "is_saved",

            "category",
            "subcategory",
            "project_type",
            "location",
            "location.country",
            "created_by",
            "created_by.legal_form",
            "payment_term",

            "skills",
            "proposals",
            "proposals.*.created_by",
            "attachments",
            "comments",
            "comments.*.created_by",
            "comments.*.children",
          ],
          "slug"
        ),
        actionTypes.Details
      )
    ).then(({ status }) => {
      if ([HTTP_PERMISSION_DENIED, HTTP_NOT_FOUND].includes(status)) {
        history.push(`/error/${status}`);
      }
    });
  };
  useEffect(() => {
    getEntity();
    setCurrentRoute(ROUTES.details.path.replace(":slug", slug));
  }, [slug, dispatch]);

  useEffect(() => {
    subheader.setTitle(`${entity.name} details`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entity, slug]);

  useEffect(() => {
    if (entity.id) {
      commentFormik.setFieldValue("project_id", entity.id);
    }
  }, [entity.id]);

  return (
    <>
      {isLoading && <ModalProgressBar />}
      {entity.id && (
        <>
          {!isReviewed(entity) && (
            <div
              className="alert alert-custom alert-primary shadow-sm fade show mb-5"
              role="alert"
            >
              <div className="alert-icon">
                <i className="flaticon-warning" />
              </div>
              <div className="alert-text d-flex justify-content-between align-items-center">
                <div
                  dangerouslySetInnerHTML={{
                    __html: formatMessage({
                      id:
                        getConfig().role === roles.super_admin
                          ? "EMY_PROJECT.DETAILS.ALERT.ADMIN_TEXT"
                          : "EMY_PROJECT.DETAILS.ALERT.TEXT",
                    }),
                  }}
                />
                <AERole accept={[roles.super_admin]}>
                  {/*TODO: Dropdown */}
                  <Dropdown as={ButtonGroup}>
                    <AEButton
                      variant={"light"}
                      fontWeight={"bolder"}
                      onClick={() => {
                        // setSortAsc(!sort.asc)
                      }}
                    >
                      {formatMessage({ id: entity.status })}
                      {/*<AESVG path={`/Navigation/${sort.asc ? 'Up':'Down'}-2.svg`} variant={"primary"}/>*/}
                      {/*{*/}
                      {/*  formatMessage({id:sorts.findIndex(o=>o.prop === sort.field) !== -1 ? sorts.find(o=>o.prop === sort.field).label:"SORT"})*/}
                      {/*}*/}

                      {/*{formatMessage({id:*/}
                      {/*    sorts.findIndex(o=>o.prop === sort.field) !== -1 ? sorts.find(o=>o.prop === sort.field).title : 'SORT'})}*/}
                    </AEButton>
                    <Dropdown.Toggle split variant="light" />
                    <Dropdown.Menu className={"py-5"}>
                      {getStatusesKeys()
                        .filter((key) => key !== entity.status)
                        .map((key) => (
                          <Dropdown.Item
                            key={key}
                            onClick={() => {
                              dispatch(
                                actions.updateEntity(
                                  { id: entity.id, status: key },
                                  actionTypes.Details
                                )
                              ).then((r) => {
                                if (r.status === HTTP_UPDATED) {
                                  getEntity();
                                }
                              });
                            }}
                          >
                            <EmyProjectStatus status={key} />
                          </Dropdown.Item>
                        ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </AERole>
              </div>
            </div>
          )}
          <EntityCard entity={entity} size={"sm"} sendProposalAction />
          <div className={"row"}>
            <div className="col-lg-8">
              <div className="card card-custom card-fit card-border gutter-b">
                <div className="card-header">
                  <div className="card-title">
                    <span className="font-weight-boldest h3">
                      {formatMessage({ id: "DESCRIPTION" })}
                      <small className={"pl-3"}>
                        <AEMoment date={entity.created_at} />
                      </small>
                    </span>
                  </div>
                </div>
                <div className="card-body pt-0">
                  <div className={"gutter-b"}>{entity.description}</div>

                  <div className={"gutter-b"}>
                    <span className="font-weight-boldest h3">
                      {formatMessage({ id: "SKILLS" })}
                    </span>
                    <div className="separator separator-solid separator-border-2 mb-3" />
                    {entity.skills.map((s) => (
                      <span
                        key={s.id}
                        className="label label-inline label-md m-1 "
                      >
                        {s[localField()]}
                      </span>
                    ))}
                  </div>

                  <div className={"gutter-b"}>
                    <span className="font-weight-boldest h3">
                      {formatMessage({ id: "ATTACHMENTS" })}
                    </span>
                    <div className="separator separator-solid separator-border-2 mb-3" />
                    {entity.attachments.map(({ id, file_name }) => (
                      <AEFileDownload
                        key={id}
                        id={id}
                        target={"project_attachments"}
                        fileName={file_name}
                      />
                    ))}
                  </div>
                  <div className={"d-flex align-items-center"}>
                    <a
                      href="#block_comments"
                      className="btn btn-hover-text-primary btn-hover-icon-primary btn-sm btn-text-dark-50 bg-hover-light-primary font-weight-bolder font-size-sm p-2"
                    >
                      <AESVG
                        path={"/Communication/Group-chat.svg"}
                        variant={"primary"}
                        size={"md"}
                        className={"pr-1"}
                      />
                      {entity.comments.length}
                    </a>
                    {/*todo saved*/}
                    <a
                      href="#"
                      className={`btn btn-sm btn-text-dark-50 ${entity.is_saved ? "text-danger" : ""
                        } bg-hover-light-danger btn-hover-text-danger font-weight-bolder font-size-sm p-2`}
                      onClick={(event) => {
                        event.preventDefault();
                        dispatch(
                          actions.toggleSave(entity.id, !entity.is_saved)
                        ).then((r) => {
                          if (r.status === HTTP_UPDATED) {
                            getEntity();
                          }
                        });
                      }}
                    >
                      <AESVG
                        path={"/General/Heart.svg"}
                        variant={entity.is_saved ? "danger" : "-"}
                        size={"md"}
                        className={"pr-1"}
                      />
                      {formatMessage({
                        id: entity.is_saved ? "SAVED" : "CLICK_TO_SAVE",
                      })}
                    </a>
                  </div>

                  {/*<div className={"gutter-b"}>*/}
                  {/*  <div className="separator separator-solid separator-border-2 mb-10"/>*/}
                  {/*  <span className="font-weight-boldest h3"> Attachments (todo multiple) : </span>*/}
                  {/*</div>*/}
                </div>
              </div>
              <div
                className="card card-custom card-fit card-border gutter-b"
                id="block_comments"
              >
                <div className="card-header">
                  <div className="card-title">
                    <span className="font-weight-boldest h3">
                      {formatMessage({ id: "COMMENTS" })}
                    </span>
                  </div>
                  <div className="card-toolbar">
                    <AEButton
                      variant={"light"}
                      fontWeight={"bolder"}
                      size={"sm"}
                      onClick={handleSubmit}
                    >
                      {formatMessage({ id: "SEND" })}
                      <AESVG
                        path={"/Communication/Send.svg"}
                        variant={"primary"}
                      />
                      {/*<span className="btn btn-text-dark-50 btn-icon-primary font-weight-bold btn-hover-bg-light mr-3">*/}
                      {/*  */}
                      {/*</span>*/}
                    </AEButton>
                  </div>
                </div>
                <div className="card-body pt-0">
                  <AEInput
                    type={"textarea"}
                    className="form-control-solid font-weight-bolder"
                    rows={4}
                    field={getFieldProps("message")}
                    form={commentFormik}
                    borderless
                    muliple
                    withFeedbackLabel={false}
                    validation={false}
                    name={"message"}
                    label={"MESSAGE"}
                    placeholder={formatMessage({ id: "COMMENT.PLACEHOLDER" })}
                  />

                  {/*<textarea rows="4" placeholder="Write a comment" className={"form-control border-0"} />*/}
                  <div className="separator separator-solid mt-9 mb-4" />
                  <div
                    className="card-scroll"
                    style={{ maxHeight: 400, minHeight: 250 }}
                  >
                    <EditableFeedWrapper
                      ReviewActions={projectCommentsActions}
                      reviews={entity.comments}
                      getEntity={getEntity}
                      authUser={authUser}
                      idField="emy_project_id" //TODO check if field is needed
                    />
                  </div>
                </div>
              </div>
              {/*<div className=scard card-custom card-fit card-border gutter-b" id="block_comments">*/}
              {/*  <div className="card-header">*/}
              {/*    <div className="card-title">*/}
              {/*      <span className="font-weight-boldest h3">*/}
              {/*        {formatMessage({id:'COMMENTS'})}*/}
              {/*      </span>*/}
              {/*    </div>*/}
              {/*    <div className="card-toolbar">*/}
              {/*      <AEButton*/}
              {/*        variant={"light"}*/}
              {/*        fontWeight={"bolder"}*/}
              {/*        size={"sm"}*/}
              {/*        onClick={commentFormik.handleSubmit}*/}
              {/*      >*/}

              {/*        {formatMessage({id:'SEND'})}*/}
              {/*        <AESVG path={"/Communication/Send.svg"} variant={"primary"}/>*/}
              {/*        /!*<span className="btn btn-text-dark-50 btn-icon-primary font-weight-bold btn-hover-bg-light mr-3">*!/*/}
              {/*        /!*  *!/*/}
              {/*        /!*</span>*!/*/}
              {/*      </AEButton>*/}
              {/*    </div>*/}
              {/*  </div>*/}
              {/*  <div className="card-body pt-0">*/}

              {/*    /!*<div className="separator separator-solid mt-9 mb-4"/>*!/*/}

              {/*    <AEInput*/}
              {/*      type={"textarea"}*/}
              {/*      className="form-control-solid font-weight-bolder"*/}
              {/*      rows={4}*/}
              {/*      field={commentFormik.getFieldProps('message')}*/}
              {/*      form={commentFormik}*/}
              {/*      borderless*/}
              {/*      muliple*/}
              {/*      withFeedbackLabel={false} validation={false}*/}
              {/*      name={"message"}*/}
              {/*      label={"MESSAGE"}*/}
              {/*      placeholder={formatMessage({id:'COMMENT.PLACEHOLDER'})}*/}
              {/*    />*/}

              {/*    /!*<textarea rows="4" placeholder="Write a comment" className={"form-control border-0"} />*!/*/}
              {/*    <div className="separator separator-solid mt-9 mb-4"/>*/}
              {/*    {*/}
              {/*      entity.comments.map(comment=>(*/}
              {/*        <AEComment key={comment.id} comment={comment} />*/}
              {/*      ))*/}
              {/*    }*/}

              {/*  </div>*/}
              {/*</div>*/}
              {/*todo if entity's owner*/}
              {Number(authUser.id) === Number(entity.user_id) ?

                  <AERole accept={[roles.client, roles.super_admin]}>
                    <Proposals
                      entities={entity.proposals}
                      onCloseModal={getEntity}
                    />
                  </AERole>

                :

                ''}
            </div>
            <div className={"col-lg-4"}>
              <div
                className="card card-custom bgi-no-repeat card-stretch gutter-b h-auto"
                style={{
                  backgroundPosition:
                    "right top" /*, backgroundSize: "30% auto"*/,
                  backgroundImage: `url(${toAbsoluteUrl(
                    "/media/svg/shapes/abstract-5.svg"
                  )})`,
                }}
              >
                <div className="card-body text-center">
                  {/* todo */}
                  {/*<AESVG icon={"/Media/Equalizer.svg"}/>*/}
                  <a
                    href="#"
                    className="card-title font-weight-bolder text-primary font-size-h6 mb-4 text-hover-state-dark d-block"
                  >
                    {formatMessage({ id: "CLIENT_BUDGET" })}
                    <span className="text-muted">
                      {[PAYMENT_TERMS.HOURLY].includes(
                        entity.payment_term._key
                      ) && ` ${formatMessage({ id: "PER_HOUR" })}`}
                    </span>
                  </a>
                  {[PAYMENT_TERMS.UNKNOWN].includes(
                    entity.payment_term._key
                  ) && <em>{formatMessage({ id: "NOT_SPECIFIED" })}</em>}
                  {[PAYMENT_TERMS.FIXED, PAYMENT_TERMS.HOURLY].includes(
                    entity.payment_term._key
                  ) && (
                      <span className="font-weight-bold font-size-sm pl-3 text-nowrap">
                        <span className=" font-weight-bolder font-size-h2 mr-2">
                          <AECurrency value={entity.price} />
                        </span>
                        {[PAYMENT_TERMS.HOURLY].includes(
                          entity.payment_term._key
                        ) && formatMessage({ id: "PER_HOUR.SHORT" })}
                      </span>
                    )}

                  {[PAYMENT_TERMS.HOURLY].includes(
                    entity.payment_term._key
                  ) && (
                      <>
                        ,
                        <span className="font-weight-bold font-size-sm pl-3">
                          <span className=" font-weight-bolder font-size-h2 mr-2">
                            {entity.hours_per_week +
                              formatMessage({ id: "HOUR.SHORT" })}
                          </span>
                          {formatMessage({ id: "WEEKLY" })}
                        </span>
                        ,
                        <span className="font-weight-bold font-size-sm pl-3">
                          <span className=" font-weight-bolder font-size-h2 mr-2">
                            {entity.duration +
                              formatMessage({ id: "HOUR.SHORT" })}
                          </span>
                          {formatMessage({ id: "DURATION" })}
                        </span>
                      </>
                    )}
                </div>
              </div>
              <div className="card card-custom bgi-no-repeat card-stretch gutter-b h-auto">
                <div className="card-body my-4">
                  <AEQRCode pathname={currentRoute} />
                </div>
              </div>
              <div
                className="card card-custom bgi-no-repeat card-stretch gutter-b h-auto"
                style={{
                  backgroundPosition:
                    "right top" /*, backgroundSize: "30% auto"*/,
                  backgroundImage: `url(${toAbsoluteUrl(
                    "/media/svg/shapes/abstract-3.svg"
                  )})`,
                }}
              >
                <div className="card-body my-4 text-center">
                  <a
                    href="#"
                    className="card-title font-weight-bolder text-primary font-size-h6 mb-4 text-hover-state-dark d-block"
                  >
                    {formatMessage(
                      { id: "PROPOSALS_RECEIVED.PLURAL" },
                      { count: entity.proposals.length }
                    )}
                  </a>
                  <div className="font-weight-bold text-muted font-size-sm">
                    {/*<AEMoment date={entity.quotes_end_at} format={"LLLL"}/>*/}
                    <span className="text-dark-75 font-weight-bold font-size-h4 ml-2">
                      {moment(entity.quotes_end_at).isAfter(moment()) ? (
                        formatMessage(
                          { id: "DAY.PLURAL" },
                          {
                            count: moment(entity.quotes_end_at).diff(
                              moment(),
                              "days"
                            ),
                          }
                        )
                      ) : (
                        <span>
                          {formatMessage({ id: "PROPOSALS_RECEIVED.ENDED" })}
                        </span>
                      )}
                    </span>
                  </div>
                </div>
              </div>

              <UserEntityCard entity={entity.created_by} size={"sm"} />

              <div className="card card-custom gutter-b card-stretch h-auto">
                <div className="card-body text-center pt-4">
                  <div className="h3 my-2 font-weight-bold">
                    {formatMessage({ id: "SHARE" })}
                  </div>
                  <AEShareButtons
                    pathname={currentRoute}
                    facebook
                    twitter
                    linkedin
                  />
                </div>
              </div>
              <AEReport />
              {/*  AEReport */}
            </div>
          </div>
        </>
      )}
    </>
  );
}
